(() => {
  if (window.Shopify && Shopify.designMode) return;

  const LS_KEY = 'gtr_age_verified';
  const COOKIE_NAME = 'gtr_age_verified';
  const ONE_YEAR_SEC = 60 * 60 * 24 * 365;
  const AGE_TRANSFER_PARAM = '_gtr_age';
  const SHOP_HOSTS = ['gtrseeds.de', 'www.gtrseeds.de', 'gtrseeds.eu', 'www.gtrseeds.eu'];

  const gate = document.getElementById('gtr-agegate');
  if (!gate || window.gtrAgeGateBound) return;
  window.gtrAgeGateBound = true;

  const ageStep = gate.querySelector('[data-gtr-step="age"]');
  const privacyStep = gate.querySelector('[data-gtr-step="privacy"]');

  let ageConfirmed = false;


  const safe = (fn, fallback = undefined) => {
    try {
      return fn();
    } catch (e) {
      return fallback;
    }
  };


  /* AGE STORAGE */

  const getCookieDomain = () => {
    const host = location.hostname.toLowerCase();

    if (
      host === 'gtrseeds.de' ||
      host.endsWith('.gtrseeds.de')
    ) {
      return '.gtrseeds.de';
    }

    if (
      host === 'gtrseeds.eu' ||
      host.endsWith('.gtrseeds.eu')
    ) {
      return '.gtrseeds.eu';
    }

    return '';
  };


  const hasCookie = () => safe(() => {
    return document.cookie
      .split(';')
      .map(value => value.trim())
      .some(value => value === COOKIE_NAME + '=1');
  }, false);


  const hasLocalStorage = () => {
    return safe(
      () => localStorage.getItem(LS_KEY) === '1',
      false
    );
  };


  const isVerified = () => {
    return ageConfirmed || hasLocalStorage() || hasCookie();
  };


  const writeCookie = () => {
    const secure =
      location.protocol === 'https:' ? '; Secure' : '';

    const domain = getCookieDomain();

    if (domain) {
      document.cookie =
        COOKIE_NAME + '=1' +
        '; Max-Age=' + ONE_YEAR_SEC +
        '; Path=/' +
        '; Domain=' + domain +
        '; SameSite=Lax' +
        secure;
    }

    document.cookie =
      COOKIE_NAME + '=1' +
      '; Max-Age=' + ONE_YEAR_SEC +
      '; Path=/' +
      '; SameSite=Lax' +
      secure;
  };


  const persistVerification = () => {
    ageConfirmed = true;
    gate.setAttribute('data-gtr-age-verified', 'true');
    safe(() => localStorage.setItem(LS_KEY, '1'));
    safe(writeCookie);
  };



  /* AGE TRANSFER: only a recently confirmed visitor from a GTR shop. */

  const shopFamily = host => host.replace(/^www\./, '');

  const ageTransfer = () => {
    if (!isVerified() || !SHOP_HOSTS.includes(location.hostname)) return null;
    return ['1', Date.now(), shopFamily(location.hostname)].join('~');
  };

  // Cart permalinks can discard unknown query parameters during their redirect.
  // A URL fragment survives an HTTP redirect and is consumed by these two assets.
  const readHandoff = url => safe(() => {
    const prefix = '#_gtr_handoff=';
    if (!url.hash.startsWith(prefix) || url.hash.length > 8192) return null;
    const data = JSON.parse(decodeURIComponent(url.hash.slice(prefix.length)));
    return data && typeof data === 'object' && typeof data.hash === 'string' &&
      (!data.hash || data.hash.startsWith('#')) && data.hash.length < 4096 ? data : null;
  }, null);

  const takeTransfer = (url, parameter, key) => {
    const handoff = readHandoff(url);
    const token = url.searchParams.get(parameter) || handoff?.[key];
    if (typeof token !== 'string' || !token) return null;
    url.searchParams.delete(parameter);
    if (handoff) {
      delete handoff[key];
      url.hash = handoff.age || handoff.consent
        ? '#_gtr_handoff=' + encodeURIComponent(JSON.stringify(handoff))
        : handoff.hash;
    }
    safe(() => history.replaceState(history.state, '', url.pathname + url.search + url.hash));
    return token;
  };

  const restoreAgeTransfer = () => {
    if (!SHOP_HOSTS.includes(location.hostname)) return false;
    const url = new URL(location.href);
    const token = takeTransfer(url, AGE_TRANSFER_PARAM, 'age');
    if (!token) return false;

    const parts = token.split('~');
    const issued = Number(parts[1]);
    const elapsed = Date.now() - issued;
    const referrer = safe(() => new URL(document.referrer), null);
    if (parts.length !== 3 || parts[0] !== '1' || !Number.isFinite(issued) ||
      elapsed < 0 || elapsed > 10 * 60 * 1000 || !referrer ||
      referrer.protocol !== 'https:' || !SHOP_HOSTS.includes(referrer.hostname) ||
      shopFamily(referrer.hostname) !== parts[2]) return false;

    persistVerification();
    return true;
  };

  // Called at the actual navigation point, after the header has built its final URL.
  // Do not create a verification or alter a non-GTR destination.
  window.GTR_prepareAgeUrl = href => {
    const url = safe(() => new URL(href, location.href), null);
    if (!url || url.protocol !== 'https:' || !SHOP_HOSTS.includes(location.hostname) ||
      !SHOP_HOSTS.includes(url.hostname) || shopFamily(url.hostname) === shopFamily(location.hostname)) return href;
    const token = ageTransfer();
    if (token) url.searchParams.set(AGE_TRANSFER_PARAM, token);
    return url.href;
  };

  const prepareShopLink = anchor => {
    const url = safe(() => new URL(anchor.href, location.href), null);
    if (!url || url.protocol !== 'https:' || !SHOP_HOSTS.includes(url.hostname) ||
      shopFamily(url.hostname) === shopFamily(location.hostname)) return;
    const token = ageTransfer();
    if (!token) return;
    url.searchParams.set(AGE_TRANSFER_PARAM, token);
    anchor.href = url.href;
    anchor.referrerPolicy = 'origin';
    anchor.rel = anchor.rel.split(/\s+/).filter(value => value !== 'noreferrer').join(' ');
  };

  const prepareLanguageForm = form => {
    if (!(form instanceof HTMLFormElement)) return;
    const action = safe(() => new URL(form.action, location.href), null);
    if (!action || action.origin !== location.origin || !/\/localization\/?$/.test(action.pathname)) return;
    const field = form.querySelector('input[name="return_to"]');
    const token = ageTransfer();
    if (!field || !token) return;
    const url = safe(() => new URL(field.value || location.pathname, location.origin), null);
    if (!url || url.origin !== location.origin) return;
    url.searchParams.set(AGE_TRANSFER_PARAM, token);
    field.value = url.pathname + url.search + url.hash;
  };

  window.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (!target) return;
    const form = target.closest('form');
    if (form) prepareLanguageForm(form);
    const anchor = target.closest('a[href]');
    if (anchor) prepareShopLink(anchor);
  }, true);

  window.addEventListener('auxclick', event => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const anchor = target?.closest('a[href]');
    if (anchor) prepareShopLink(anchor);
  }, true);

  document.addEventListener('submit', event => prepareLanguageForm(event.target), true);

  /* AGE UI ONLY. The cookie asset owns the privacy step. */

  const openAge = () => {
    if (ageStep) ageStep.hidden = false;
    if (privacyStep) privacyStep.hidden = true;
    gate.classList.add('is-open');
    gate.classList.remove('gtr-cookie-step-active');
    gate.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gtr-agegate-open');
    requestAnimationFrame(() => {
      if (!isVerified()) gate.querySelector('[data-agegate="yes"]')?.focus({ preventScroll: true });
    });
  };

  const closeAge = () => {
    if (ageStep) ageStep.hidden = true;
    // Do not close an active cookie choice or manually opened preferences.
    if (privacyStep && !privacyStep.hidden) return;
    gate.classList.remove('is-open');
    gate.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gtr-agegate-open');
  };

  const syncState = () => {
    gate.setAttribute('data-gtr-age-ready', 'true');
    if (!isVerified()) {
      gate.setAttribute('data-gtr-age-verified', 'false');
      openAge();
      document.dispatchEvent(new CustomEvent('gtr:age-required'));
      return;
    }
    persistVerification();
    closeAge();
    document.dispatchEvent(new CustomEvent('gtr:age-ready'));
  };

  const confirmAge = () => {
    persistVerification();
    closeAge();
    document.dispatchEvent(new CustomEvent('gtr:age-verified'));
  };

  gate.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const button = target?.closest('[data-agegate]');
    if (!button) return;
    if (button.getAttribute('data-agegate') === 'yes') confirmAge();
    else if (button.getAttribute('data-agegate') === 'no') window.location.href = 'https://www.google.com/';
  });

  window.addEventListener('storage', event => {
    if (event.key !== LS_KEY || event.newValue !== '1') return;
    persistVerification();
    syncState();
    document.dispatchEvent(new CustomEvent('gtr:age-verified'));
  });
  window.addEventListener('pageshow', syncState);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) syncState(); });

  restoreAgeTransfer();
  syncState();
})();